import { USER_INFO } from "../common/constant";
import { buildMode } from "../common/environment";

export const setTitlePage = (title: string) => {
  document.title = `Trang mua sắm sản phẩm Kymdan chính hãng - ${title}`;
};

export const getUserInfo = () => {
  const json = localStorage.getItem(USER_INFO)
  if (!json) {
    return null;
  }
  return JSON.parse(`${json}`);
}

const WHITELIST_PHONE_NUMBER = ["0385411800"]

export const checkContextMenu = () => {
  const user = getUserInfo()
  document.oncontextmenu = () => {
    if (buildMode === "development") {
      return true;
    } else if (user?.phone_number && WHITELIST_PHONE_NUMBER.includes(user?.phone_number)) {
      return true;
    }
    return false;
  };
};

export const isProduction = () => {
  return buildMode === "production"
}
